import { Icon, type IIconStyles } from '@fluentui/react';
import type { FC, MouseEventHandler } from 'react';

import { useTheme } from '@shared-legacy/ui-kit';

import { getDocsCollapseButtonIconStyle, getDocsCollapseButtonStyle } from '../styles/docsProvider.styles';

export type DocsCollapseButtonProps = {
  onClick: MouseEventHandler<HTMLButtonElement>;
};

export const DocsCollapseButton: FC<DocsCollapseButtonProps> = ({ onClick }) => {
  const theme = useTheme();

  return (
    <button
      type="button"
      aria-label="Close documentation sidebar"
      title="Close documentation sidebar"
      onClick={onClick}
      style={getDocsCollapseButtonStyle(theme)}
      data-test="docs-collapse-button"
    >
      <Icon iconName="ChevronRight" styles={getDocsCollapseButtonIconStyle(theme) as IIconStyles} />
    </button>
  );
};
